const url = '/api/v1'
const url2 = ''

const url3 = 'https://bor.intechs.by/api/v1'
const url4 = 'https://bor.intechs.by'

const url5 = 'https://rgooboor.by/api/v1'
const url6 = 'https://rgooboor.by'

export const config = {
  defaultImg: '',
  endpoint: url,
  auth: url2,
}
